import React from "react"
import ReactDOM from "react-dom"

import HotTable from "../../utils/hot-table";
import Handsontable from "handsontable";

import CatRenderer from './footer-renderer'
import SubTableRenderer from './sub-table-renderer'
import CellRenderer from './cell-renderer'

class SFPHotTable extends React.Component {
    hiddenRowId;

    render() {
        return (

            <HotTable
                autoRowSize={true}
                ref="table"
                root={this.props.root}
                afterChange={this._handleChange.bind(this)}
                afterOnCellMouseDown={this._handleMouseDown.bind(this)}
                settings={this._getSettings()}
                beforeKeyDown={this._handleKeyDown.bind(this)}
            />
        )
    }

    getInstance() {
        return this.refs.table.hotInstance
    }

    componentDidMount() {
        if (!window.hot_instances) window.hot_instances = []

        var index = window.hot_instances.map(h => (h.root)).indexOf(this.props.root)
        if (index !== -1) {
            window.hot_instances.splice(index, 1)
        }

        window.hot_instances.push({ root: this.props.root, instance: this })
    }

    componentWillUnmount() {
        if (window.hot_instances) {
            window.hot_instances.splice(window.hot_instances.map(h => (h.root)).indexOf(this.props.root), 1)
        }
    }

    _getFixedSettings = () => {
        var settings = this._getSettings()
        settings.data = settings.data.map(d => [d[0]])
        //settings.data.splice(settings.data.length - 1, 1)
        //settings.colHeaders = null
        return settings
    }

    _getSettings = () => {

        var headers = this.props.headers
        if (headers) {
            headers.unshift(this.props.title || "")
        }

        let noValue = []
        let synthesisIndex = []

        const synthesisClassname = ["first-header", "cat-footer", "ppi-total"]

        if (this.props.currentTab === "synthesis") {
            this.props.tableDefinition.rows.filter((r, index) => {
                if (synthesisClassname.includes(r.className)) synthesisIndex.push(index)
            })
        }

        const synthesisIndexSet = new Set(synthesisIndex)

        let hideData = this.props.data.filter((data, index) => {
            if (synthesisIndexSet.has(index)) return true
            let hasValue = false
            for (let i = 0; i < data.length; i++) {
                const value = data[i]
                if (typeof value === "number" && value !== 0) { hasValue = true; break }
                if (typeof value === "object" && value && value.value !== 0) { hasValue = true; break }
            }
            if (!hasValue) noValue.push(index)
            return hasValue;
        })

        const noValueSet = new Set(noValue)
        let hideRows = this.props.tableDefinition.rows.filter((r, index) => {
            return !noValueSet.has(index)
        })
        this.hiddenRowId = noValue;
        let tableDefinition = this.props.hideRows ? hideRows : this.props.tableDefinition.rows
        let data = this.props.hideRows ? hideData : this.props.data

        const mergedAreas = tableDefinition.filter(row => (row.rowComponent || row.isHeader)).map(row => {
            return {
                row: row.index,
                col: 0,
                rowspan: 1,
                colspan: this.props.headers.length
            }
        })

        var hiddenRows = []
        tableDefinition.map((r, index) => {
            if (r.mayBeHidden) {
                if (data[index]) {
                    let hasNonEmpty = false
                    for (let i = 1; i < data[index].length; i++) {
                        const d = data[index][i]
                        if (d !== "" && d !== 0 && d !== null) { hasNonEmpty = true; break }
                    }
                    if (!hasNonEmpty) hiddenRows.push(index)
                }
            }
        })
        const hiddenRowsSet = new Set(hiddenRows)

        var colWidths = [this.props.firstColWidth || 200]
        if (data[0]) {
            for (var i = 0; i < data[0].length - 1; i++) {
                colWidths.push(150)
            }
        }

        // Pre-compute cell props per row to avoid recomputing on every cell callback
        const precomputedRowProps = new Map()
        for (let ri = 0; ri < tableDefinition.length; ri++) {
            const row = tableDefinition[ri]
            if (!row) continue

            const isHidden = hiddenRowsSet.has(ri)
            const baseCellProps = row.cellProps ? { ...row.cellProps } : {}
            baseCellProps.readOnly = row.readOnly || false
            baseCellProps.disableVisualSelection = row.readOnly || false
            if (isHidden) {
                baseCellProps.className = "hidden-row"
            } else if (row.className) {
                baseCellProps.className = row.className
            }

            // Pre-index editable/disabled cells as Sets for O(1) lookup
            const editableSet = row.editableCells ? new Set(row.editableCells) : null
            const disabledSet = row.disabledCells ? new Set(row.disabledCells) : null

            // Pre-index cellComponents for fast column lookup
            let cellComponentMap = null
            if (row.cellComponents) {
                cellComponentMap = new Map()
                for (const cl of row.cellComponents) {
                    if (cl.indices) {
                        for (const idx of cl.indices) cellComponentMap.set(idx, cl)
                    } else if (cl.index !== undefined) {
                        cellComponentMap.set(cl.index, cl)
                    }
                }
            }

            precomputedRowProps.set(ri, {
                row,
                baseCellProps,
                editableSet,
                disabledSet,
                cellComponentMap,
                isHidden,
            })
        }

        const thisProps = this.props

        return {
            allowInsertRow: false,
            data: data,
            fillHandle: "vertical",
            colHeaders: headers,
            stretchH: "all",
            renderAllRows: true,
            viewportColumnRenderingOffset: headers.length,
            fixedColumnsLeft: this.props.fixedColumnLeft,
            mergeCells: mergedAreas,
            colWidths,
            hiddenRows: {
                rows: hiddenRows,
                indicators: false
            },
            cells: (r, c, prop) => {
                const precomp = precomputedRowProps.get(r)
                if (!precomp) return {}

                const { row, baseCellProps, editableSet, disabledSet, cellComponentMap } = precomp

                let cellProps
                if (c > 0) {
                    cellProps = { ...baseCellProps }
                } else {
                    cellProps = { readOnly: true }
                    if (baseCellProps.className) cellProps.className = baseCellProps.className
                }

                if (editableSet) {
                    cellProps.readOnly = !editableSet.has(c)
                }

                if (disabledSet && disabledSet.has(c)) {
                    cellProps.readOnly = true
                }

                if (row.rowComponent && c == 0) {
                    cellProps.renderer = SubTableRenderer(row, thisProps)
                } else if (cellComponentMap) {
                    const cellComponent = cellComponentMap.get(c)
                    if (cellComponent) {
                        cellProps.renderer = CellRenderer(cellComponent, row, thisProps, c)
                    }
                }

                return cellProps
            }
        }
    }

    _handleChange = (
        /** @type {CellInfo[]} */ cells,
        /** @type {String} */   source) => {
        if (this.props.onChange) {
            this.props.onChange(this.props.root, cells, source, this.hiddenRowId)
        }
    }

    _handleKeyDown(e) {
        window.hot_instances.map(h => {
            if (h.root !== this.props.root) {
                h.instance.handleSubTableKeyDown(e)
            }
        })
    }

    _handleMouseDown(e, coords) {
        if (this.props.onMouseDown) this.props.onMouseDown(coords)
    }

    handleSubTableKeyDown(e) {
        if (this.refs.table) {
            let editor = this.refs.table.hotInstance.getActiveEditor()
            if (editor) {
                switch (e.keyCode) {
                    case 13:
                        editor.finishEditing()
                        break
                    case 8:
                        if (editor.getValue()) {
                            let value = editor.getValue().substr(0, editor.getValue().length - 1)
                            editor.setValue(value == "" ? null : value)
                        }
                        break
                }
            }
        }
    }

}

export default SFPHotTable



// WEBPACK FOOTER //
// ./src/component/scenarii/common/hot-table.js